import client from "./axiosConfig";

export const getAttendanceList = (params) => {
  const config = {
    url: "/attendance/",
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const getAttendanceKpi = (params) => {
  const config = {
    url: "/attendance/kpi/",
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const getAttendanceKpiUsers = (params) => {
  const config = {
    url: "/attendance/kpi/users/",
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const markAttenadance = (data) => {
  const config = {
    url: "/attendance/",
    method: "POST",
    data,
  };
  const response = client(config);
  return response;
};

export const backDated = (data) => {
  const config = {
    url: "/attendance/backdated/",
    method: "POST",
    data,
  };
  const response = client(config);
  return response;
};

export const reviewAttendance = (id, data) => {
  const config = {
    url: `/attendance/review/${id}/`,
    method: "PATCH",
    data,
  };
  const response = client(config);
  return response;
};

export const getDetailedViewById = (id) => {
  const config = {
    url: `/attendance/${id}`,
    method: "GET"
  }
  const response = client(config);
  return response;
}
